<template>
  <div class="multi-select-field">
    <div v-for="field in selectFields" :key="field.id" class="field-wrap">
      <a class="remove" href="#" @click.prevent="remove(field.id)">
        <CloseIcon />
      </a>
      <Field
        type="select"
        :options="options"
        :name="`${name}[]`"
        v-model="field.value"
        @change="select(field.id)"
      />
    </div>
    <a class="add" href="#" @click.prevent="add()">
      <span class="icon">
        <icon icon="close" />
      </span>
      <span class="text">{{ addLabel }}</span>
    </a>
  </div>
</template>

<script>
import Str from "helpers/Str";
export default {
  props: {
    name: { type: String, required: true },
    options: { type: Array, required: true },
    value: { type: Array, default: () => [] },
    addLabel: { type: String, default: "Add Additional Field" }
  },
  data() {
    return {
      selectFields: []
    };
  },
  computed: {
    selectFieldIds() {
      let ids = [];
      if (this.selectFields.length > 0) {
        this.selectFields.forEach(field => {
          ids.push(field.id);
        });
      }
      return ids;
    },
    selections() {
      let selections = [];
      if (this.selectFields.length > 0) {
        this.selectFields.forEach(field => {
          if (!!field.value) {
            selections.push(field.value);
          }
        });
      }
      return selections;
    }
  },
  watch: {
    value(val) {
      this.load();
    },
    selections(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    load() {
      this.selectFields = [];
      if (this.value.length > 0) {
        this.value.forEach(value => {
          var id = this.generateRandomId();
          this.selectFields.push({ id: id, value: value });
        });
      } else {
        this.add();
      }
    },
    add() {
      var id = this.generateRandomId();
      this.selectFields.push({ id: id, value: null });
    },
    remove(id) {
      let selectFields = this.selectFields;
      this.selectFields = [];
      this.selectFields = selectFields.filter(field => {
        return field.id != id;
      });
    },
    select(id) {
      this.$nextTick(() => {
        var selectField = this.selectFields.find(field => field.id == id);
        if (this.isDuplicate(selectField.value)) {
          this.deselect(id);
          alert(
            "You have already assigned this value. Please make a different selection."
          );
        }
      });
    },
    deselect(id) {
      let selectFields = this.selectFields;
      this.selectFields = [];
      this.selectFields = selectFields.map(field => {
        if (field.id == id) {
          field.value = null;
        }
        return field;
      });
    },
    isDuplicate(value) {
      var matches = this.selectFields.filter(field => {
        return field.value == value;
      });
      return matches.length > 1;
    },
    generateRandomId() {
      let id = Str.random();
      while (this.selectFieldIds.includes(id)) {
        id = Str.random();
      }
      return id;
    }
  },
  mounted() {
    this.load();
  }
};
</script>
